import OperationalReportPage from './OperationalReportPage';
export default function CouponPerformanceReportPage(){return <OperationalReportPage kind="coupon-performance"/>;}
